/** @format */

import styled from "styled-components";
import { Alert } from "antd";

export const UIAlert = styled(Alert)`
  border-radius: 7px;
`;
